export default "__VITE_ASSET__4cb7b2cf__"